// @flow

import type { EapState } from "./types";

export const initialState: EapState = {
  requestsInProgress: 0,
  schema: null,
  list: null,
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  configuration: {
    enabled: true,
  },
  modals: {
    showAddModal: false,
    modalStep: 1,
    showEditModal: false,
    showEditAssignmentsModal: false,
    showDiscardModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
};

export default initialState;
